/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './facet.defs.js'
export * as $defs from './facet.defs.js'
